import LoadMore from './LoadMore';

const loadMoreConfig = {
  name: 'loadMore',
  class: LoadMore,
  querySelector: {
    buttonAnchor: '.article-card-list__cta a',
    button: '.article-card-list__cta',
  },
};

export default loadMoreConfig;



// WEBPACK FOOTER //
// ./client/js/components/LoadMore/loadMoreConfig.js